export enum TwoFactorEmailOtpContext {
  Login = 'login',
  Setup = 'setup',
  Reveal = 'reveal',
  Regenerate = 'regenerate'
}
